// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockWithVerticalTitle_root__Y4ygU","wrapper":"BlockWithVerticalTitle_wrapper__KLzeq","items":"BlockWithVerticalTitle_items__kT_Ni"};